import { TranslateService } from '@ngx-translate/core';
import { Message } from 'primeng/components/common/api';
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-g-message',
	templateUrl: './g-message.component.html',
	styleUrls: ['./g-message.component.css']
})
export class GMessageComponent implements OnInit {

	msgs: Message[] = [];

	constructor(private translateService: TranslateService) { }

	ngOnInit() { }

    success(message = '', time = 3000) {
        this.msgs.push({severity: 'success', summary: 'Sucesso', detail: message});
        setTimeout(() => {
            this.msgs.splice(-1, 1);
        }, time);
    }

    warn(message = 'Requisição concluída com falhas.', time = 3000) {
        this.msgs.push({severity: 'warn', summary: 'Atenção', detail: message});
        setTimeout(() => {
            this.msgs.splice(-1, 1);
        }, time);
    }

    info(message = '', time = 3000) {
        this.msgs.push({severity: 'info', summary: 'Info', detail: message});
        setTimeout(() => {
            this.msgs.splice(-1, 1);
        }, time);
    }

    error(message = 'Ocorreu um erro. Contate o suporte.', time = 3000) {
        this.msgs.push({severity: 'error', summary: 'Erro', detail: message});
        setTimeout(() => {
            this.msgs.splice(-1, 1);
        }, time);
    }

    clear() {
        this.msgs.splice(-1, 1);
    }

    translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/g-message/g-message.component.ts